import React from "react";
import {
  Container,
  Grid,
  Skeleton,
  Box,
  Stack,
} from "@mui/material";
import { DividerGradient } from "../../Gradient";

/**
 * Shimmer loading component for CareersPage
 * Matches the structure of CareersHero, JobCard, and Sidebar components
 */
const CareersPageShimmer = () => {
  return (
    <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
      {/* Hero Skeleton */}
      <Box
        sx={{
          textAlign: "center",
          mb: 10,
          py: 8,
          px: 4,
          borderRadius: 3,
          backgroundColor: "transparent",
          backdropFilter: "blur(12px)",
          border: (theme) =>
            `1px solid ${
              theme.palette.mode === "dark"
                ? "rgba(255,255,255,0.08)"
                : "rgba(0,0,0,0.08)"
            }`,
          boxShadow: (theme) =>
            theme.palette.mode === "dark"
              ? "0 2px 8px rgba(0,0,0,0.1)"
              : "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        <Skeleton
          variant="text"
          width="60%"
          height={56}
          sx={{ mx: "auto", mb: 2 }}
        />
        <Skeleton
          variant="text"
          width="80%"
          height={32}
          sx={{ mx: "auto", mb: 3 }}
        />
        <Skeleton variant="text" width="40%" height={24} sx={{ mx: "auto" }} />
      </Box>

      <Box sx={{ my: 8 }}>
        <DividerGradient orientation="horizontal" width="100%" height={2} />
      </Box>

      <Grid container spacing={4}>
        {/* Job Cards Skeleton */}
        <Grid item xs={12} md={8}>
          <Stack spacing={3}>
            {[...Array(3)].map((_, i) => (
              <Box
                key={i}
                sx={{
                  p: 4,
                  borderRadius: 3,
                  backgroundColor: "transparent",
                  backdropFilter: "blur(12px)",
                  border: (theme) =>
                    `1px solid ${
                      theme.palette.mode === "dark"
                        ? "rgba(255,255,255,0.08)"
                        : "rgba(0,0,0,0.08)"
                    }`,
                  boxShadow: (theme) =>
                    theme.palette.mode === "dark"
                      ? "0 2px 8px rgba(0,0,0,0.1)"
                      : "0 2px 8px rgba(0,0,0,0.05)",
                }}
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="start"
                  spacing={2}
                  sx={{ mb: 2 }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      sx={{ mb: 1.5 }}
                    >
                      <Skeleton variant="text" width="40%" height={32} />
                      <Skeleton
                        variant="rounded"
                        width={60}
                        height={24}
                        sx={{ borderRadius: 2 }}
                      />
                    </Stack>
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{ mb: 2, flexWrap: "wrap" }}
                    >
                      <Skeleton variant="text" width={100} height={20} />
                      <Skeleton variant="text" width={120} height={20} />
                    </Stack>
                    <Skeleton variant="text" width="100%" height={20} />
                    <Skeleton variant="text" width="90%" height={20} />
                    <Skeleton variant="text" width="80%" height={20} sx={{ mb: 2 }} />
                    <Skeleton variant="text" width={120} height={20} />
                  </Box>
                  <Skeleton
                    variant="circular"
                    width={40}
                    height={40}
                  />
                </Stack>
              </Box>
            ))}
          </Stack>
        </Grid>

        {/* Sidebar Skeleton */}
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 5,
              p: 3,
              borderRadius: 3,
              backgroundColor: "transparent",
              backdropFilter: "blur(12px)",
              border: (theme) =>
                `1px solid ${
                  theme.palette.mode === "dark"
                    ? "rgba(255,255,255,0.08)"
                    : "rgba(0,0,0,0.08)"
                }`,
              boxShadow: (theme) =>
                theme.palette.mode === "dark"
                  ? "0 2px 8px rgba(0,0,0,0.1)"
                  : "0 2px 8px rgba(0,0,0,0.05)",
            }}
          >
            <Skeleton
              variant="rounded"
              width="100%"
              height={40}
              sx={{ borderRadius: 2 }}
            />
            <Box>
              <Skeleton variant="text" width="50%" height={24} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="100%" height={1} sx={{ mb: 2 }} />
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="90%" height={20} />
            </Box>
            <Box>
              <Skeleton variant="text" width="60%" height={24} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="100%" height={1} sx={{ mb: 2 }} />
              <Stack spacing={1}>
                {[...Array(4)].map((_, i) => (
                  <Skeleton
                    key={i}
                    variant="rounded"
                    width="100%"
                    height={36}
                    sx={{ borderRadius: 2 }}
                  />
                ))}
              </Stack>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default CareersPageShimmer;

